export default "__VITE_ASSET__Lo3wm_ie__"